import { render, staticRenderFns } from "./JobAgentWidget.vue?vue&type=template&id=63cf49b6&"
import script from "./JobAgentWidget.vue?vue&type=script&lang=js&"
export * from "./JobAgentWidget.vue?vue&type=script&lang=js&"
import style0 from "./JobAgentWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports